// TODO: replace with the backend OTP flow (/api/form/generate-otp/ + /api/form/verify-token/).
// Hardcoded for now: anyone who knows this code can pass the portal OTP step.
export const PORTAL_TEST_OTP = '123456';
export const PORTAL_OTP_LENGTH = PORTAL_TEST_OTP.length;

// sessionStorage: phone entered on the login step, read by the OTP step.
export const PORTAL_PENDING_PHONE_KEY = 'portal_pending_phone';
// localStorage: survives reopening the site from the home screen icon.
export const PORTAL_VERIFIED_PHONE_KEY = 'portal_verified_phone';

export const isValidIndianMobile = (phone: string) => /^[6-9]\d{9}$/.test(phone);

export const readStorage = (storage: 'local' | 'session', key: string): string | null => {
  try {
    return (storage === 'local' ? localStorage : sessionStorage).getItem(key);
  } catch {
    return null;
  }
};

export const writeStorage = (storage: 'local' | 'session', key: string, value: string) => {
  try {
    (storage === 'local' ? localStorage : sessionStorage).setItem(key, value);
  } catch {
    // Private mode / blocked storage: the flow still works within the current page.
  }
};
